module.exports = __webpack_public_path__ + "fonts/MTSCompact-Medium.36c2e6b.woff2";